import * as React from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { FormikFormGroup } from "components/common";
const SynchronizeGroupsCheckbox = ({ disabled }) => {
  const { t } = useTranslation("enterprise_authentication");
  const { values, setErrors } = useFormikContext();
  const _onChange = (event) => {
    if (values.synchronizeGroups && !event.target.checked) {
      setErrors({});
    }
  };
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      label: t("directory_services.group_sync_checkbox.label"),
      id: "synchronize-groups-checkbox",
      disabled,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        label: t("directory_services.group_sync_checkbox.synchronize_groups"),
        onChange: _onChange,
        disabled,
        wrapperClassName: "col-sm-12",
        name: "synchronizeGroups",
        help: t("directory_services.group_sync_checkbox.help"),
        type: "checkbox"
      }
    )
  );
};
export default SynchronizeGroupsCheckbox;
